import { render, staticRenderFns } from "./CustomSelectItem.vue?vue&type=template&id=82b528d0&scoped=true&"
import script from "./CustomSelectItem.vue?vue&type=script&lang=js&"
export * from "./CustomSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectItem.vue?vue&type=style&index=0&id=82b528d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b528d0",
  null
  
)

export default component.exports